import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "「type転職エージェント」アプリをエキスパートレビュー・ペルソナ設計・カスタマージャーニーによるUX再構築で全面刷新。アプリストア評価は2.9から4.5へ、利用者は10%増を達成。UX/UIデザイン・開発・内製化支援をワンチームで担ったキャリアデザインセンターの開発事例です。"

const ogpImg = "https://aitria.co.jp/images/img/cases/cdc/ogp_cdc.png"

export const careerDesignCenterPageMeta: PageMeta = {
  title: "利用者10%増・アプリ評価2.9→4.5｜転職アプリUX/UI改善と内製化支援事例 | Aitria（アイトリア）",
  description,
  keyword: "事例 実績 スマホアプリ type転職 キャリアデザインセンター cdc",
  image: ogpImg,
  url: `${SITE_URL}/cases/career-design-center/`,
}

export const careerDesignCenterSchema = buildCaseStudySchema({
  slug: "career-design-center",
  pageTitle: careerDesignCenterPageMeta.title,
  description: careerDesignCenterPageMeta.description,
  headline: "利用者10％増 - UX/UI改善で転職成功に必須のアプリを開発",
  alternativeHeadline: "株式会社キャリアデザインセンター",
  primaryImage: ogpImg,
  images: [ogpImg,"https://aitria.co.jp/images/img/cases/cdc/mv.webp"],
  clientName: "株式会社キャリアデザインセンター",
  breadcrumbLabel: "利用者10％増 - UX/UI改善で転職成功に必須のアプリを開発",
})
